<div class="mwp-modal">
    <div class="header">
        <mwp-text-translate text="Verification Documents For:" jsonKey="verificationDocumentsFor" class="me-1" />{{dependentName}}
    </div>
    <div class="body">
        <mwp-table [tableColumns]="documentColumns" [dataSource]="documentMatTableData" [isModal]="true" />
    </div>
    <div class="footer d-flex justify-content-end w-100">
        <button class="mwp-button-secondary" (click)="closeDialog()">
            <mwp-text-translate text="Cancel" jsonKey="cancel" />
        </button>
    </div>
</div>